import React, { useEffect, useState } from "react";
import trans from "../../../../utils";
import { Input } from "../../../Helpers/Input/Input";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import { useGetMapPOISQuery } from "../../../../Redux/service/POIS/POIs";
import { useGetFloorplansQuery } from "../../../../Redux/service/ProjectSetup/ProjectSetup";

import { useParams } from "react-router-dom";

export default function OfflineSetupControlLocation({
	addConfig,
	setFloorplan,
	setRooms,
	uniqueId,
	setUniqueId,
}) {
	const [id, setId] = useState();
	const [type, setType] = useState(null);
	const [buildings, setBuildings] = useState([]);
	const [levels, setLevels] = useState([]);
	let { data: ProjectData } = useGetMapPOISQuery({
		status: true,
		queryString: "&type=project",
	});
	const { data: floorplans, isSuccess } = useGetFloorplansQuery(
		{ id: id },
		{ skip: !id },
	);
	const param = useParams();

	useEffect(() => {
		if (id) {
			if (type === "building") {
				setBuildings(floorplans?.data?.rooms || []);
				setLevels([]);
			} else if (type === "level") {
				setLevels(floorplans?.data?.rooms || []);
			}
		}
	}, [floorplans, type, id]);
	useEffect(() => {
		if (floorplans) {
			setFloorplan(floorplans?.data?.floorPlan?.imageUrl);
			setRooms(floorplans?.data?.rooms);
		}
	}, [floorplans]);
	useEffect(() => {
		if (!addConfig.values.buildingId) {
			setId(addConfig.values.projectId);
		}
	}, [addConfig.values.buildingId]);
	useEffect(() => {
		if (uniqueId) {
			if (type === "building") {
				addConfig.setFieldValue("buildingId", uniqueId);
				setId(uniqueId);
				setType("level");
			} else if (type === "level") {
				addConfig.setFieldValue("levelId", uniqueId);
			} else {
				return;
			}
		}
	}, [uniqueId]);
	useEffect(() => {
		if (param?.id && addConfig.values.projectId) {
			setId(addConfig.values.projectId);
			setType("building");
		}
	}, [param?.id, addConfig.values.projectId]);
	useEffect(() => {
		if (
			param?.id &&
			isSuccess &&
			type === "building" &&
			addConfig.values.buildingId
		) {
			setId(addConfig.values.buildingId);
			setType("level");
		}
	}, [isSuccess]);
	return (
		<div style={{ paddingInline: "16px", marginBlock: "16px" }}>
			<div
				style={{
					color: "#0F6936",
					fontWeight: "500",
					fontSize: "16px",
					marginBottom: "16px",
				}}
			>
				{trans("Select Location")}
			</div>
			<Input
				title={trans("Configuration Name")}
				type="text"
				placeholder={trans("Enter Configuration name")}
				id="name"
				name="name"
				formstyle="mb-2"
				onBlur={(e) => addConfig.handleBlur(e)}
				onChange={(e) => addConfig.handleChange(e)}
				errors={addConfig.errors.name}
				touched={addConfig.touched.name}
				value={addConfig.values.name || ""}
			/>
			<InputSelect
				label="Project"
				id="projectId"
				name="projectId"
				placeholder={trans("Select Project")}
				className="w-100"
				style={{ width: "100%" }}
				formstyle="mb-2"
				options={ProjectData?.data?.map((i) => ({
					label: i?.name,
					value: i?.id,
				}))}
				errors={addConfig.errors.projectId}
				touched={addConfig.touched.projectId}
				onBlur={() => addConfig.setFieldTouched("projectId", true)}
				onChange={async (val) => {
					console.log(val);
					await addConfig.setFieldValue("projectId", val);
					if (addConfig.values.buildingId) {
						addConfig.setFieldValue("buildingId", null);
						addConfig.setFieldValue("levelId", null);
						setLevels([]);
						setBuildings([]);
					}
					setId(val);
				}}
				onSelect={() => setType("building")}
				onClear={() => {
					setType(null);
					setFloorplan(null);
					setRooms([]);
				}}
				value={addConfig.values.projectId || undefined}
			/>
			<InputSelect
				label="Building"
				id="buildingId"
				name="buildingId"
				placeholder={trans("Select Building")}
				className="w-100"
				style={{ width: "100%" }}
				formstyle="mb-2"
				options={buildings?.map((i) => ({
					label: i?.displayName,
					value: i?.id,
				}))}
				errors={addConfig.errors.buildingId}
				touched={addConfig.touched.buildingId}
				onBlur={() => addConfig.setFieldTouched("buildingId", true)}
				onChange={(val) => {
					addConfig.setFieldValue("buildingId", val);
					addConfig.setFieldValue("levelId", null);
					setLevels([]);
					setId(val);
				}}
				onClear={() => {
					setType("building");
					setUniqueId(null);
				}}
				onSelect={() => setType("level")}
				value={addConfig.values.buildingId || undefined}
			/>
			<InputSelect
				label="Level"
				id="levelId"
				name="levelId"
				placeholder={trans("Select Level")}
				className="w-100"
				style={{ width: "100%" }}
				formstyle="mb-2"
				options={levels?.map((i) => ({
					label: i?.displayName,
					value: i?.id,
				}))}
				errors={addConfig.errors.levelId}
				touched={addConfig.touched.levelId}
				onBlur={() => addConfig.setFieldTouched("levelId", true)}
				onChange={(val) => addConfig.setFieldValue("levelId", val)}
				onClear={() => {
					setUniqueId(null);
				}}
				value={addConfig.values.levelId || undefined}
			/>
		</div>
	);
}
